class CookieBanner extends HTMLElement {
  constructor() {
    super();

    this.classes = {
      activeClass: 'is-active',
      closingClass: 'is-closing'
    };
    this.banner = this.querySelector('.cookie-banner');

    if (this.dataset.testMode === 'true') {
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.close.bind(this))
      );
    }
    else {
      // ROHO 09/2026: Shopify.loadFeatures ist nicht immer vorhanden
      // (blockierte Skripte, In-App-Browser, konkurrierende Consent-Apps).
      // Fehler still abfangen statt ungefangen in die Konsole werfen.
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
        return;
      }

      try {
        window.Shopify.loadFeatures([
          {
            name: 'consent-tracking-api',
            version: '0.1',
          }
        ],
        (error) => {
          if (error) {
            // Kein erneutes throw: ein ungefangener Fehler hier stoppt alle
            // nachfolgenden Skripte auf der Seite.
            console.warn('[cookie-banner] consent-tracking-api konnte nicht geladen werden:', error);
            return;
          }

          this.beforeInit();
        });
      } catch (error) {
        console.warn('[cookie-banner] consent-tracking-api konnte nicht geladen werden:', error);
      }
    }
  }

  connectedCallback() {
    if (Shopify.designMode) {
      this.onShopifySectionLoad = this.onSectionLoad.bind(this);
      this.onShopifySectionSelect = this.onSectionSelect.bind(this);
      this.onShopifySectionDeselect = this.onSectionDeselect.bind(this);
      document.addEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.addEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.addEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  disconnectedCallback() {
    if (Shopify.designMode) {
      document.removeEventListener('shopify:section:load', this.onShopifySectionLoad);
      document.removeEventListener('shopify:section:select', this.onShopifySectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onShopifySectionDeselect);
    }
  }
  onSectionLoad(event) {
    filterShopifyEvent(event, this, () => this.open.bind(this));
  }
  onSectionSelect(event) {
    filterShopifyEvent(event, this, this.open.bind(this));
  }
  onSectionDeselect(event) {
    filterShopifyEvent(event, this, this.close.bind(this));
  }

  // Liefert customerPrivacy nur zurueck, wenn es wirklich benutzbar ist.
  get privacy() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!privacy
      || typeof privacy.userCanBeTracked !== 'function'
      || typeof privacy.getTrackingConsent !== 'function') {
      return null;
    }

    return privacy;
  }

  beforeInit() {
    const privacy = this.privacy;

    if (!privacy) {
      console.warn('[cookie-banner] Shopify.customerPrivacy nicht verfuegbar - Banner wird nicht angezeigt.');
      return;
    }

    let userCanBeTracked;
    let userTrackingConsent;

    try {
      userCanBeTracked = privacy.userCanBeTracked();
      userTrackingConsent = privacy.getTrackingConsent();
    } catch (error) {
      console.warn('[cookie-banner] Consent-Status nicht lesbar:', error);
      return;
    }

    if (!window.location.pathname.match(/^(\/[a-z]{2}(-[A-Z]{2})?)?\/cart$/) && !userCanBeTracked && userTrackingConsent === 'no_interaction') {
      this.init();

      this.querySelectorAll('.button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  }

  init() {
    if (Shopify && Shopify.designMode) {
      return;
    }

    setTimeout(function() {
      this.open();
    }.bind(this), parseInt(this.dataset.delay) * 1000);
  }

  open() {
    this.banner.classList.add(this.classes.activeClass);
  }

  close() {
    this.banner.classList.add(this.classes.closingClass);

    setTimeout(() => {
      this.banner.classList.remove(this.classes.activeClass);
      this.banner.classList.remove(this.classes.closingClass);
    }, 500);
  }

  onButtonClick(event) {
    event.preventDefault();
    this.close();

    const privacy = this.privacy;

    if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
      return;
    }

    try {
      privacy.setTrackingConsent(event.target.name === 'accept', this.noop);
    } catch (error) {
      console.warn('[cookie-banner] Consent konnte nicht gespeichert werden:', error);
    }
  }

  noop() {
  }
}
customElements.define('cookie-banner', CookieBanner);
